<template>
  <div>
    <div class="flex items-center justify-between mt-2 flex-wrap">
      <div class="py-2">
        <page-header
        heading="Locations"
        breadcrumb=""
      />
      </div>
     <div class="w-full sm:w-6/12 py-2">
      <search-filter  @getSearchString="getSearchString"/>
     </div>
    </div>

    <div class="bg-white shadow py-6 mt-8">
      <locations-table :searchString="searchString"/>
    </div>
  </div>
</template>

<script>
import PageHeader from "../PageHeader.vue";
import SearchFilter from "../Locations/modules/SearchFilter.vue";
import LocationsTable from "./LocationsTable";
export default {
  components: {
    PageHeader,
    SearchFilter,
    LocationsTable,
  },
  data() {
    return {
      searchString: ""
    }
  },
  methods: {
    getSearchString(val){
       this.searchString = val
    }
  },
};
</script>

<style></style>
